import React from "react";
import {Loading} from "./icons/Loading";

export const LoadingDNA = () => (
    <div className="inner-content">
        <div className="loading-container">
            <Loading width="150" height="75"/>
        </div>
    </div>
);